module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAbCAYAAACN1PRVAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACZSURBVHgB7dRdCYVAEAXgs3ID3AhGsInawCo2sIGYwAgawQZWsMF6RvFF/EGYBcH5YF5W8MCcZQFjnvDed15XDBMUd1zIIIDo4Czm1AxstcuNLr5lnJGBEvxH4DDRcxrn3AQFv5Nz+XnJkAohcWWJ1tq+w+0PuELpKYWenN0PZ2HSl2Znk9ZtNoujzgqs76OWauvs7rky7zMDAqSCSQr5Qb0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/treeactive.png
// module id = t4Bm
// module chunks = 1